import React from "react";

const Parametros = ({ numSet, selectedSet, onChangeSet }) => {
  return (
    <div className="">
      {/* Abas de Sets */}
      <span className="text-xs text-gray-500">Sets:</span>
      <div className="flex  mb-4">
        {[...Array(Number(numSet)).keys()].map((i) => {
          const setNum = String(i + 1);
          const isSelected = selectedSet === setNum;

          return (
            <button
              key={setNum}
              onClick={() => onChangeSet(setNum)}
              className={`w-[80px] h-[30px] rounded-t-md flex items-center justify-center text-sm font-medium border border-base-300 ${
                isSelected ? "border-b-4 border-b-blue-500" : "border-b"
              } ${isSelected ? "bg-base-200" : "bg-base-100"}`}
            >
              {setNum}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Parametros;
